import { FC } from 'react'
import Loading from './common/loading/Loading'
import { icons } from '../icons/IconSet'
import { Alert, AlertTitle } from '@mui/material'
import TooltipWrapper from './common/TooltipWrapper'
import { magentoApi } from '../services/magento.api'

const ServerAvailability: FC = () => {
  const { data, isFetching, isLoading } = magentoApi.useIsServerAvailableQuery({})

  return (
    ((isFetching || isLoading) && <Loading />) ||
    (data?.isServerAvailable && (
      <div className='flex items-center gap-2'>
        <TooltipWrapper content='Aim Server is available'>
          {icons('server', { stroke: 'green' })}
        </TooltipWrapper>
      </div>
    )) ||
    (!data?.isServerAvailable /* === false*/ && (
      <div className='flex items-center gap-2'>
        {icons('server-off', { stroke: 'rgb(220 38 38)' })}
        <div className='flex flex-col  text-red-600 text-xs py-1 px-2'>
          <div className=' font-semibold uppercase'>Server is off</div>
          <div className=''>Aim Server is unavailable!</div>
        </div>
      </div>
    )) ||
    null
  )
}

export default ServerAvailability
